export default __webpack_public_path__ + "static/media/018-pickup truck.774bbb09.svg";